"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../../utils/index.js";
import { Label } from "../../Label/index.js";
import { Checkbox } from "../Checkbox/Checkbox.js";
import { checkboxVariants } from "../Checkbox/Checkbox.variants.js";
const CheckboxWithLabel = (props)=>{
    const { emphasis, size = '20', labelClassName, labelProps = {}, labelNode, accessibleLabel, isCheckboxGroup = false, layout, ...restProps } = props;
    const { labelSlot } = checkboxVariants({
        size,
        emphasis,
        isCheckboxGroup,
        layout
    });
    const labelClasses = cn(labelSlot(), labelClassName);
    return /*#__PURE__*/ jsxs(Label, {
        className: labelClasses,
        ...labelProps,
        children: [
            /*#__PURE__*/ jsx(Checkbox, {
                size: size,
                emphasis: emphasis,
                isCheckboxGroup: isCheckboxGroup,
                "aria-label": accessibleLabel,
                ...restProps
            }),
            labelNode
        ]
    });
};
export { CheckboxWithLabel };
